'use es6';

import { ACTION_HUB_OPT_IN, ACTION_USER_OPT_IN } from 'ui-addon-opt/state/OptActions';
import AdditionalOptionsPropType from './AdditionalOptionsPropType';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PositionedBetaButton from './PositionedBetaButton';
import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import emptyFunction from 'react-utils/emptyFunction';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Optin = ({
  additionalOptions,
  dispatch,
  learnMore,
  onLearnMoreClick,
  onMinimized,
  onView,
  optInButtonText,
  showIcon,
  showHubOptin,
  showUserOptin
}) => {
  return /*#__PURE__*/_jsx(UIDropdown, {
    Button: PositionedBetaButton,
    buttonText: optInButtonText,
    icon: showIcon ? undefined : 'none',
    onOpenComplete: onView,
    "data-test-id": "dropdown",
    children: /*#__PURE__*/_jsxs(UIList, {
      "data-test-id": "dropdownList",
      children: [showUserOptin && /*#__PURE__*/_jsx(UIButton, {
        onClick: () => dispatch({
          type: ACTION_USER_OPT_IN
        }),
        "data-test-id": "userOptinButton",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-addon-opt.optin.options.userOptin"
        })
      }), showHubOptin && /*#__PURE__*/_jsx(UIButton, {
        onClick: () => dispatch({
          type: ACTION_HUB_OPT_IN
        }),
        "data-test-id": "hubOptinButton",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-addon-opt.optin.options.hubOptin"
        })
      }), learnMore && /*#__PURE__*/_jsx(UIButton, {
        href: learnMore.url,
        onClick: onLearnMoreClick,
        target: "_blank",
        "data-test-id": "learnMoreButton",
        children: learnMore.text
      }), additionalOptions && additionalOptions.map(({
        text,
        onClick
      }, idx) => /*#__PURE__*/_jsx(UIButton, {
        onClick: onClick,
        "data-test-id": `additionalOptionsButton${idx}`,
        children: text
      }, `option-${idx}`)), /*#__PURE__*/_jsx(UIButton, {
        onClick: onMinimized,
        "data-test-id": "minimizeButton",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-addon-opt.common.options.minimize"
        })
      })]
    })
  });
};
Optin.propTypes = {
  additionalOptions: AdditionalOptionsPropType,
  dispatch: PropTypes.func.isRequired,
  learnMore: PropTypes.shape({
    text: PropTypes.node.isRequired,
    url: PropTypes.string.isRequired
  }),
  onLearnMoreClick: PropTypes.func.isRequired,
  onMinimized: PropTypes.func.isRequired,
  onView: PropTypes.func,
  optInButtonText: PropTypes.node.isRequired,
  showIcon: PropTypes.bool.isRequired,
  showHubOptin: PropTypes.bool.isRequired,
  showUserOptin: PropTypes.bool.isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
Optin.defaultProps = {
  onLearnMoreClick: emptyFunction,
  onMinimized: emptyFunction,
  onView: emptyFunction,
  optInButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "ui-addon-opt.optin.label"
  }),
  showHubOptin: false,
  showUserOptin: true,
  showIcon: true
};
export default Optin;